import React from 'react';
import './Contact.css';
// On importe la barre de réassurance
import FeatureBar from '../Accueil/components/FeatureBar';

function Contact() {
  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>Nous Contacter</h1>
        <p>Une question, une suggestion ou une demande de commande ? Nous sommes à votre écoute.</p>
      </div>

      {/* --- Encart explicatif pour le processus de commande --- */}
      <div className="order-process-info">
        <div className="order-process-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6C4.9 6 4 6.9 4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm8 14H4V8h2v1c0 .55.45 1 1 1s1-.45 1-1V8h4v1c0 .55.45 1 1 1s1-.45 1-1V8h2v12z" /></svg>
        </div>
        <div className="order-process-text">
          <h4>Finaliser votre commande</h4>
          <p>
            Pour commander les articles de votre panier, contactez-moi directement par <strong>email</strong> ou par <strong>téléphone</strong>. 
            Je vous répondrai avec plaisir très rapidement pour valider votre achat.
          </p>
        </div>
      </div>

      <div className="contact-body">
        {/* Colonne de gauche avec les informations directes */}
        <div className="contact-details">
          <h3>Informations</h3>
          <div className="contact-info-item">
            <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" /></svg>
            <span>101 impasse rançon,<br />32130 POLASTRON</span>
          </div>
          <div className="contact-info-item">
            <svg viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" /></svg>
            <a href="tel:+33668150574">06 68 15 05 74</a>
          </div>
          <div className="contact-info-item">
            <svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" /></svg>
            <a href="mailto:couleursirene@gmail.com">couleursirene@gmail.com</a>
          </div>


          {/* --- Ajout de la carte interactive --- */}
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2903.606775697668!2d0.812226376662788!3d43.45037846175109!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a9202302302e69%3A0x6335435a2307224f!2s101%20Imp.%20Ran%C3%A7on%2C%2032130%20Polastron!5e0!3m2!1sfr!2sfr!4v1720163351239!5m2!1sfr!2sfr"
              title="Carte de localisation de Couleur Sirène"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>

        {/* Plus de formulaire ici */}
      </div>

      {/* --- Information sur les frais de livraison --- */}
      <div className="shipping-info-standalone">
        <div className="shipping-info-header">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
          </svg>
          <h4>Livraison</h4>
        </div>
        <p>
          <strong>Frais de livraison :</strong> Des frais de livraison s'appliquent.
          Le montant exact vous sera communiqué lors de la finalisation de votre commande.
        </p>
        <div className="shipping-methods">
          <span className="shipping-method">📦 Colissimo</span>
          <span className="shipping-method">🏪 Point Relais</span>
        </div>
      </div>

      {/* --- On ajoute la barre de réassurance ici --- */}
      <div className="contact-feature-bar-wrapper">
        <FeatureBar />
      </div>
    </div>
  );
}

export default Contact;